import { NotificationService } from 'src/app/shared/services/notification.service';
import { inject, Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ActivityServices } from '../services/activities.services';
import { SelectItem, ConfirmationService, LazyLoadEvent, SortEvent } from 'primeng/api';
import { HelperService } from 'src/app/_services/helper.service';
import { BaseServices } from 'src/app/kuba/kuba.services';
import { FeatureKey, Rights } from 'src/app/_models';
import { TranslateService } from '@ngx-translate/core';
import { PaginationRequestClass } from '../../shared/models/pagination-request-class';
import { Table } from 'primeng/table';
import { Observable, Subscription } from 'rxjs';
import { Select } from 'primeng/select';
import { PagedResponse } from '../../shared/models/pagedResponse';
import { ActivityListDto } from '../models/activityListDto';
import { ActivityFilterDto } from '../models/activityFilterRequest';
import { ActivityMetadataFilterDto } from '../models/activityMetadataFilterRequest';
import { MultiDeleteResultDto, BulkStopRecurringActivitiesResult } from '../models/activities';
import { ProgressLoaderConfig } from '../../shared/components/progress-loader/progress-loader.component';
import { FilterStateService } from '../../shared/services/filter-state.service';
import { NavigationEnd } from '@angular/router';
import { DatePickerOptions } from 'src/app/_helpers/date-setting';

@Component({
  selector: 'activity-list',
  templateUrl: 'activity-list.component.html',
  styleUrls: ['activity-list.component.scss'],
  standalone: false
})
export class ActivityListComponent implements OnInit, AfterViewInit {
  //#region variables

  @ViewChild('activityTable', { static: false }) activityTable: Table;
  private readonly notifications = inject(NotificationService);
  @ViewChild('progressLoader', { static: false }) progressLoader: any;

  // References to filter input fields
  @ViewChild('noFilterInput', { static: false }) noFilterInput: any;
  @ViewChild('businessNameFilterInput', { static: false }) businessNameFilterInput: any;
  @ViewChild('titleFilterInput', { static: false }) titleFilterInput: any;
  @ViewChild('departmentFilterInput', { static: false }) departmentFilterInput: any;
  @ViewChild('descriptionFilterInput', { static: false }) descriptionFilterInput: any;
  @ViewChild('followupFilterInput', { static: false }) followupFilterInput: any;
  @ViewChild('responsiblePersonFilterInput', { static: false }) responsiblePersonFilterInput: any;
  @ViewChild('createdByNameFilterInput', { static: false }) createdByNameFilterInput: any;
  @ViewChild('status', { static: false }) statusDropdown: Select;
  @ViewChild('repetitionDropdown', { static: false }) repetitionDropdown: Select;

  activityListMetadata: any;
  activityList: ActivityListDto[] = [];
  repetitions: any;
  activityFilterDto: ActivityFilterDto = {};
  showActivities: any;
  vresperson: SelectItem[];
  selectedFollowUpPerson: any = null;
  businesses: SelectItem[];
  doneOn: any;
  follows: any[];
  public isLoadingData: boolean = false;
  ActivityForm: FormGroup;
  isShowActivity = true;
  enablePaginator = true;

  vDepartment: SelectItem[];
  portalContacts: SelectItem[];
  statuses: SelectItem[];
  isAdministrateActivity: boolean;
  isDisableDeleteIcon = true;
  additionalData: any;
  totalRecords = 0;
  isAdmin = true;
  isNewButtonEnable: boolean;
  private loadingSubscription: Subscription;
  isNotAdmin = false;
  roleId: string;
  isBusiness = false;
  startDate: string;
  endDate: string;
  totalItems: number;
  originalActivity: any;
  userId: number;
  newActivityTitle: string;
  showFilter = false;
  responsibleFollowUpFilter: any = null;
  repetitionFilter: any = null;
  doneOnFilter: any = null;
  fromDateFilter: any = null;
  endDateFilter: any = null;
  iscreatedToFilter = true;
  rowsPerPageOptions: any = [];
  saveButtonClicked: boolean;
  selectedBusiness: any = [];
  currentBusinessId: number;
  private filterDebounceTimer: any;
  public startDateOptions: DatePickerOptions = {
    dateFormat: 'dd/mm/yyyy',
    editableDateField: false,
    openSelectorOnInputClick: true,
    firstDayOfWeek: 'su',
    satHighlight: true,
    selectionTxtFontSize: '14px',
    height: '32px',
    todayBtnTxt: this.translate.instant('TODAY'),
    dayLabels: {
      su: this.translate.instant('SUN'),
      mo: this.translate.instant('MON'),
      tu: this.translate.instant('TUE'),
      we: this.translate.instant('WED'),
      th: this.translate.instant('THU'),
      fr: this.translate.instant('FRI'),
      sa: this.translate.instant('SAT')
    },
    monthLabels: {
      1: this.translate.instant('JANUARY'),
      2: this.translate.instant('FEBRUARY'),
      3: this.translate.instant('MARCH'),
      4: this.translate.instant('APRIL'),
      5: this.translate.instant('MAY'),
      6: this.translate.instant('JUNE'),
      7: this.translate.instant('JULY'),
      8: this.translate.instant('AUGUST'),
      9: this.translate.instant('SEPTEMBER'),
      10: this.translate.instant('OCTOBER'),
      11: this.translate.instant('NOVEMBER'),
      12: this.translate.instant('DECEMBER')
    },
    disableSince: this.getCurrentDate()
  };
  paginationRequest: PaginationRequestClass = {
    pageNumber: 1,
    pageSize: 10,
    sortColumn: undefined,
    sortDirection: 'ASC'
  };
  totalPages: number = 0;
  noFilter: string | undefined = undefined;
  businessNameFilter: string | undefined = undefined;
  titleFilter: string | undefined = undefined;
  departmentFilter: string | undefined = undefined;
  followupFilter: string | undefined = undefined;
  descriptionFilter: string | undefined = undefined;
  responsiblePersonFilter: string | undefined = undefined;
  createdByNameFilter: string | undefined = undefined;

  selectedFilters: {
    topic: string | null;
    case: string | null;
    followUp: string | null;
    execution: string | null;
    department: string | null;
    businessName: string | null;
    repetition: string | null;
    DoneDateFrom: String | null;
    DoneDateTo: String | null;
  } = {
      topic: null,
      case: null,
      followUp: null,
      execution: null,
      department: null,
      businessName: null,
      repetition: null,
      DoneDateFrom: null,
      DoneDateTo: null
    };
  private columnMapping: { [key: string]: string } = {
    'No': 'No',
    'Title': 'Title',
    'BusinessName': 'BusinessName',
    'ExecutionUserList': 'ExecutionUserList',
    'FollowupUserList': 'FollowupUserList',
    'EndDateForPdf': 'Deadline',
    'CreatedOn': 'CreatedOn',
    'DoneOn': 'DoneOn',
    'PriorityOrder': 'PriorityOrder',
    'Status': 'Status',
    // Admin level specific mappings
    'ActivityNumber': 'ActivityNumber',
    'CompanyName': 'CompanyName',
    'EndDate': 'EndDate',
    'CompletedDate': 'CompletedDate'
  };

  rowsPerPage: number = 10; // default page size
  currentPage: number = 0;

  displayDialog = false;
  displayDialogForRecurring = false;
  newActivityForm: FormGroup;
  loading = false;
  recurringActivityId = 0;
  IsFutureRecurring: boolean;
  public endDateOptions: DatePickerOptions = this.startDateOptions;
  isDisableShowActivity = false;
  totalrecords: number;
  private subscriptions: Subscription[] = [];
  isPortal: boolean = true;
  isEditor: boolean = true;
  showSave = false;
  selectedBusinessId: any;
  isPortalAccess: boolean;
  userrights: any;
  myactivity: boolean = false;
  selectedActivity: string;
  selectedDepartment: any = null;
  showFilters: boolean = false; // Control filter visibility

  // New properties for Show Activity filter
  showActivityFilter: string = 'all'; // 'all' or 'for me'
  showActivityOptions = [
    { label: '', value: 'all' },
    { label: '', value: 'for me' }
  ];

  // Export progress dialog properties
  exportInProgress: boolean = false;
  private exportDialogTimeout: any = null;

  // Metadata filter properties
  metadataFilter: ActivityMetadataFilterDto = {};
  
  // Year pagination properties
  currentYear: number = new Date().getFullYear();
  selectedYear: number = new Date().getFullYear();
  isYearPaginationActive: boolean = false;
  
  // Multi-select properties - using same approach as employee table
  selectedActivities: ActivityListDto[] = [];
  isAllSelected: boolean = false;
  allSelectedActivities: Set<number> = new Set(); // Track all selected activity IDs across pages
  allSelectedRecurringActivities: Set<number> = new Set(); // Track all selected recurring activity IDs across pages
  justStoppedRecurrence: boolean = false; // Flag to disable button after stopping recurrence

  // Multi-delete progress properties
  isDeletingActivities: boolean = false;
  deletingProgress: number = 0;
  totalActivitiesToDelete: number = 0;
  estimatedTimeRemaining: number = 0;
  initialEstimatedTime: number = 0;

  // Multi-stop recurrence progress properties
  isStoppingRecurrence: boolean = false;
  stoppingProgress: number = 0;
  totalActivitiesToStop: number = 0;
  stoppingEstimatedTimeRemaining: number = 0;
  stoppingInitialEstimatedTime: number = 0;

  // Progress loader configuration
  progressLoaderConfig: ProgressLoaderConfig = {
    isVisible: false,
    title: '',
    message: '',
    progress: 0,
    totalItems: 0,
    estimatedTimeRemaining: 0,
    initialEstimatedTime: 0,
    showProgressBar: true,
    showTimeRemaining: true,
    showItemCount: true
  };

  // Filter state management
  private readonly FILTER_MODULE_KEY = 'followup_activities';
  private isRestoringFilters = false;

  //#endregion

  //#region contructor
  /**
   * @param activityService {ActivityServices}
   * @param route {ActivatedRoute}
   * @param router {Router}
   * @param _fb {FormBuilder}
   * @param confirmationService {ConfirmationService}
   */
  constructor(
    private activityService: ActivityServices,
    private route: ActivatedRoute,
    public router: Router,
    public _fb: FormBuilder,
    private confirmationService: ConfirmationService,
    private translate: TranslateService,
    private filterStateService: FilterStateService
  ) {
    this.userId = BaseServices.UserId;

    // Initialize activityFilterDto
    this.activityFilterDto = {};

    this.ActivityForm = this._fb.group({
      DoneOn: [''],
      FollowupUserName: ['']
    });

    // Then subscribe to language changes
    this.subscriptions.push(
      this.translate.stream(['SHOW_ACTIVITY', 'ALL', 'FOR_ME', 'FOR_YOU']).subscribe(translations => {

        this.showActivityOptions = [
          { label: translations['ALL'], value: 'all' },
          { label: translations['FOR_ME'], value: 'for me' }
        ];

      })
    );

    this.subscriptions.push(
      this.translate.stream('FILENAME').subscribe(val => {
        if (BaseServices.roleId == '1') {
          // Admin level - include all columns
          this.additionalData = {
            fileName: val.ACTIVITY_LIST,
            header: 'Activity List',
            businessId: BaseServices.BusinessId,
            cultureInfo: BaseServices.userCultureInfo(),
            columnNames: [
              { title: 'Activity Number', dataKey: 'No' },
              { title: 'Title', dataKey: 'Title' },
              { title: 'Status', dataKey: 'Status' },
              { title: 'Repetitions', dataKey: 'repetitions' },
              { title: 'Department', dataKey: 'Department' },
              { title: 'Description', dataKey: 'Description' },
              { title: 'Execution UserName', dataKey: 'ExecutionUserList' },
              { title: 'Followup UserName', dataKey: 'FollowupUserList' },
              { title: 'Deadline', dataKey: 'EndDateForPdf' },
              { title: 'Business', dataKey: 'BusinessName' },
              { title: 'Created On', dataKey: 'CreatedOn' },
              { title: 'Done On', dataKey: 'CompletedDate' }
            ]
          };
        } else if (BaseServices.roleId == '2') {
          // Portal level
          this.additionalData = {
            fileName: val.ACTIVITY_LIST,
            header: 'Activity List',
            businessId: BaseServices.BusinessId,
            cultureInfo: BaseServices.userCultureInfo(),
            columnNames: [
              { title: 'Activity Number', dataKey: 'No' },
              { title: 'Business', dataKey: 'BusinessName' },
              { title: 'Title', dataKey: 'Title' },
              { title: 'Status', dataKey: 'Status' },
              { title: 'Repetitions', dataKey: 'repetitions' },
              { title: 'Department', dataKey: 'Department' },
              { title: 'Description', dataKey: 'Description' },
              { title: 'Execution UserName', dataKey: 'ExecutionUserList' },
              { title: 'Followup UserName', dataKey: 'FollowupUserList' },
              { title: 'Deadline', dataKey: 'EndDateForPdf' },
              { title: 'Created On', dataKey: 'CreatedOn' },
              { title: 'Done On', dataKey: 'CompletedDate' }
            ]
          };
        } else {
          // Business level
          this.additionalData = {
            fileName: val.ACTIVITY_LIST,
            header: 'Activity List',
            businessId: BaseServices.BusinessId,
            cultureInfo: BaseServices.userCultureInfo(),
            columnNames: [
              { title: 'Activity Number', dataKey: 'No' },
              { title: 'Title', dataKey: 'Title' },
              { title: 'Status', dataKey: 'Status' },
              { title: 'Repetitions', dataKey: 'repetitions' },
              { title: 'Department', dataKey: 'Department' },
              { title: 'Description', dataKey: 'Description' },
              { title: 'Execution UserName', dataKey: 'ExecutionUserList' },
              { title: 'Followup UserName', dataKey: 'FollowupUserList' },
              { title: 'Deadline', dataKey: 'EndDateForPdf' },
              { title: 'Created On', dataKey: 'CreatedOn' },
              { title: 'Done On', dataKey: 'CompletedDate' }
            ]
          };
        }
      })
    );
    this.newActivityTitle = this.translate.instant('NEW_ACTIVITY');
    this.newActivityForm = this._fb.group({
      Status: this.newActivityTitle,
      Title: ['', Validators.required],
      Description: ['']
    });
    this.saveButtonClicked = false;

    // Set up navigation detection
    this.setupNavigationDetection();
  }

  /**
   * Set up navigation detection to clear filters when leaving the followup module
   */
  private setupNavigationDetection(): void {
    this.subscriptions.push(
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          const currentUrl = event.urlAfterRedirects;
          
          // Check if navigating outside the follow-up module
          if (!currentUrl.includes('/follow-up')) {
            // Clear filter state when leaving the module
            this.filterStateService.clearFilterState(this.FILTER_MODULE_KEY);
          }
        }
      })
    );
  }

  /**
   * Save current filter state to sessionStorage
   */
  private saveFilterStateToStorage(): void {
    if (this.isRestoringFilters) {
      return; // Don't save while restoring to avoid overwriting
    }

    try {
      const filterState = {
        // Filter DTO properties
        activityFilterDto: this.activityFilterDto,
        
        // Text filters
        noFilter: this.noFilter,
        businessNameFilter: this.businessNameFilter,
        titleFilter: this.titleFilter,
        departmentFilter: this.departmentFilter,
        followupFilter: this.followupFilter,
        descriptionFilter: this.descriptionFilter,
        responsiblePersonFilter: this.responsiblePersonFilter,
        createdByNameFilter: this.createdByNameFilter,
        
        // Dropdown selections
        selectedFollowUpPerson: this.selectedFollowUpPerson,
        selectedDepartment: this.selectedDepartment,
        showActivityFilter: this.showActivityFilter,
        repetitionFilter: this.repetitionFilter,
        
        // Date filters
        startDate: this.startDate,
        endDate: this.endDate,
        fromDateFilter: this.fromDateFilter,
        endDateFilter: this.endDateFilter,
        
        // Selected filters tracking
        selectedFilters: this.selectedFilters,
        
        // Year pagination
        selectedYear: this.selectedYear,
        isYearPaginationActive: this.isYearPaginationActive
      };

      this.filterStateService.saveFilterState(this.FILTER_MODULE_KEY, filterState);
      
      // Save pagination state
      this.filterStateService.savePaginationState(this.FILTER_MODULE_KEY, {
        pageNumber: this.paginationRequest.pageNumber,
        pageSize: this.paginationRequest.pageSize
      });
      
      // Save sorting state
      this.filterStateService.saveSortingState(this.FILTER_MODULE_KEY, {
        sortColumn: this.paginationRequest.sortColumn,
        sortDirection: this.paginationRequest.sortDirection
      });
    } catch (error) {
      console.error('Error saving filter state:', error);
    }
  }

  /**
   * Restore filter state from sessionStorage
   */
  private restoreFilterStateFromStorage(): void {
    try {
      this.isRestoringFilters = true;

      const savedState = this.filterStateService.getFilterState<any>(this.FILTER_MODULE_KEY);
      
      if (savedState) {
        // Restore filter DTO
        if (savedState.activityFilterDto) {
          this.activityFilterDto = { ...savedState.activityFilterDto };
        }
        
        // Restore text filters
        this.noFilter = savedState.noFilter;
        this.businessNameFilter = savedState.businessNameFilter;
        this.titleFilter = savedState.titleFilter;
        this.departmentFilter = savedState.departmentFilter;
        this.followupFilter = savedState.followupFilter;
        this.descriptionFilter = savedState.descriptionFilter;
        this.responsiblePersonFilter = savedState.responsiblePersonFilter;
        this.createdByNameFilter = savedState.createdByNameFilter;
        
        // Restore dropdown selections
        this.selectedFollowUpPerson = savedState.selectedFollowUpPerson || null;
        this.selectedDepartment = savedState.selectedDepartment || null;
        this.showActivityFilter = savedState.showActivityFilter || 'all';
        this.repetitionFilter = savedState.repetitionFilter || null;
        
        // Restore date filters
        this.startDate = savedState.startDate;
        this.endDate = savedState.endDate;
        // Convert date strings back to Date objects for p-calendar components
        this.fromDateFilter = savedState.fromDateFilter ? new Date(savedState.fromDateFilter) : null;
        this.endDateFilter = savedState.endDateFilter ? new Date(savedState.endDateFilter) : null;
        
        // Restore selected filters
        if (savedState.selectedFilters) {
          this.selectedFilters = { ...savedState.selectedFilters };
        }
        
        // Restore year pagination
        if (savedState.selectedYear !== undefined) {
          this.selectedYear = savedState.selectedYear;
        }
        if (savedState.isYearPaginationActive !== undefined) {
          this.isYearPaginationActive = savedState.isYearPaginationActive;
        }
      }
      
      // Restore pagination state
      const savedPagination = this.filterStateService.getPaginationState<any>(this.FILTER_MODULE_KEY);
      if (savedPagination) {
        this.paginationRequest.pageNumber = savedPagination.pageNumber || 1;
        this.paginationRequest.pageSize = savedPagination.pageSize || 10;
      }
      
      // Restore sorting state
      const savedSorting = this.filterStateService.getSortingState<any>(this.FILTER_MODULE_KEY);
      if (savedSorting) {
        this.paginationRequest.sortColumn = savedSorting.sortColumn;
        this.paginationRequest.sortDirection = savedSorting.sortDirection || 'ASC';
      }

      this.isRestoringFilters = false;
    } catch (error) {
      console.error('Error restoring filter state:', error);
      this.isRestoringFilters = false;
    }
  }

  //#endregion

  //#region page-event
  /**
   * binding dropdowns and list of activities
   */
  ngOnInit(): void {
    document.querySelector('body').classList.remove('opened');
    
    // Restore filter state from sessionStorage before initializing
    this.restoreFilterStateFromStorage();
    
    this.loading = true; // Show loading during initialization

    // Initialize selectedDepartment and vDepartment
    this.selectedDepartment = this.selectedDepartment || null;
    this.vDepartment = [];

    // Initialize activityFilterDto if not already initialized
    if (!this.activityFilterDto) {
      this.activityFilterDto = {};
    }

    // Check if route data is available
    const routeData = this.route.snapshot.data;

    // Initialize vDepartment with fallback if route data is not available
    if (routeData && routeData['departments'] && Array.isArray(routeData['departments'])) {
      this.vDepartment = [
        { label: 'Select', value: null },
        ...routeData['departments'].map((dept: any) => ({
          label: dept.Name,
          value: dept.Id
        }))
      ];
    }

    this.bindDetails(BaseServices.BusinessId);
    this.SelectedActivityList();
    this.displayDialog = false;
    if (this.activityList != null) {
      this.totalrecords = this.activityList.length;
    }
    if (BaseServices.roleId !== '1' && BaseServices.roleId !== '2') {
      if (this.activityList) {
        this.subscriptions.push(
          this.activityService
            .getActivityResponsible(+BaseServices.BusinessId)
            .subscribe((res: any) => {
              this.activityList.forEach((element: any) => {
                if (element.Status !== 'NEW') {
                  element.ExecutionUserIdList = res.activity_Execution
                    .filter((x: any) => x.ActivityId === element.Id)
                    .map(({ UserId }: any) => UserId);
                  element.FollowupUserIdList = res.activity_FollowUp
                    .filter((x: any) => x.ActivityId === element.Id)
                    .map(({ UserId }: any) => UserId);
                }
              });
            })
        );
      }
    }
    this.bindBusiness();

    // Role-based access control setup
    if (BaseServices.roleId === '1') {
      // Admin level
      this.isDisableDeleteIcon = false;
      this.isAdmin = true;
      this.isNewButtonEnable = false;
      this.isNotAdmin = false;
      this.isShowActivity = false;
      this.isBusiness = true;
    } else if (BaseServices.roleId === '2') {
      // Portal level
      this.isDisableDeleteIcon = false;
      this.isNotAdmin = true;
      this.isNewButtonEnable = true;
      this.isAdmin = false;
      this.isBusiness = true;
      this.isShowActivity = false;
    } else if (BaseServices.roleId === '5') {
      // User level (business level)
      let currentUserRole = BaseServices.UserRole;
      let userRightsId = Rights.ADMINISTRATE_ACTIVITIES;
      this.isNewButtonEnable = BaseServices.checkUserRights(
        userRightsId,
        currentUserRole
      );
      // Business level users (Editor, User, Guest) are not admin
      this.isAdmin = false;
      this.isNotAdmin = true;
    } else {
      // Editor level (business level) - roleId === '3'
      this.isNewButtonEnable = BaseServices.roleId === '3' ? true : false;
      this.isNotAdmin = true;
      // Business level users (Editor, User, Guest) are not admin
      this.isAdmin = false;
    }
    
    // Check for ADMINISTRATE_ACTIVITIES right to enable delete functionality
    if (BaseServices.roleId === '5') {
      let currentUserRole = BaseServices.UserRole;
      let userRightsId = Rights.ADMINISTRATE_ACTIVITIES;
      let hasAdministrateRight = BaseServices.checkUserRights(
        userRightsId,
        currentUserRole
      );
      // Enable delete functionality if user has ADMINISTRATE_ACTIVITIES right
      this.isDisableDeleteIcon = hasAdministrateRight ? false : true;
    } else if (BaseServices.roleId === '3') {
      // Editor has delete rights
      this.isDisableDeleteIcon = false;
    }
    if (window.name === 'Remote') {
      this.isDisableShowActivity = true;
    }
    // To hide side menu bar
    document.querySelector('body').classList.remove('opened');

    this.onAdministrateActivity();
    this.roleId = BaseServices.roleId;

    let portalContacts = this.route.snapshot.data['portalContacts'];
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.newActivityTitle = this.translate.instant('NEW_ACTIVITY');
        this.newActivityForm = this._fb.group({
          Status: this.newActivityTitle,
          Title: ['', Validators.required],
          Description: ['']
        });
        this.portalContacts = [];
        this.portalContacts.push({ label: val.SELECT, value: null });
      })
    );
    if (portalContacts) {
      portalContacts.forEach((portalContact: any) => {
        this.portalContacts.push({
          label: portalContact.Name,
          value: portalContact.Id
        });
      });
    }
    // Loading state is managed by loadActivities method
    this.showSave =
      BaseServices.roleId == '2' && this.selectedBusinessId > 0 ? true : false;
    this.selectedBusinessId = +sessionStorage.getItem('CurrentBusinessId');
    this.isPortal = BaseServices.roleId == '2' ? true : false;
    this.isEditor = BaseServices.roleId == '3' ? true : false;
    if (this.roleId == '2') {
      this.isPortalAccess = this.selectedBusinessId > 0 ? false : true;
    } else {
      this.isPortalAccess = false;
    }
    // Check for the 'openDialog' query param
    this.route.queryParams.subscribe(params => {
      if (params['openDialog'] === 'true') {
        this.displayDialog = true;
      } else {
        this.displayDialog = false;
      }
    });
    
  }

  /**
   * After view initialization - populate filter inputs with restored values
   */
  ngAfterViewInit(): void {
    // Use setTimeout to ensure all view children are initialized
    // Multiple timeouts to handle async data loading for dropdown options
    setTimeout(() => {
      this.populateFilterInputs();
    }, 0);
    
    // Additional delay for dropdown options that might load asynchronously
    setTimeout(() => {
      this.populateFilterInputs();
    }, 300);
    
    // Final attempt to ensure all async data is loaded
    setTimeout(() => {
      this.populateFilterInputs();
    }, 800);
  }

  /**
   * Populate filter input fields with restored values from sessionStorage
   */
  private populateFilterInputs(): void {
    // Populate text input fields that don't have ngModel binding
    if (this.noFilterInput && this.noFilter) {
      this.noFilterInput.nativeElement.value = this.noFilter;
    }
    
    if (this.businessNameFilterInput && this.businessNameFilter) {
      this.businessNameFilterInput.nativeElement.value = this.businessNameFilter;
    }
    
    if (this.titleFilterInput && this.titleFilter) {
      this.titleFilterInput.nativeElement.value = this.titleFilter;
    }
    
    if (this.descriptionFilterInput && this.descriptionFilter) {
      this.descriptionFilterInput.nativeElement.value = this.descriptionFilter;
    }
    
    if (this.responsiblePersonFilterInput && this.responsiblePersonFilter) {
      this.responsiblePersonFilterInput.nativeElement.value = this.responsiblePersonFilter;
    }

    if (this.createdByNameFilterInput && this.createdByNameFilter) {
      this.createdByNameFilterInput.nativeElement.value = this.createdByNameFilter;
    }
    
    // Status dropdown
    if (this.statusDropdown && this.activityFilterDto.status) {
      if (this.statuses && this.statuses.length > 0) {
        const statusOption = this.statuses.find((s: any) => s.value === parseInt(this.activityFilterDto.status as string));
        if (statusOption) {
          this.statusDropdown.value = parseInt(this.activityFilterDto.status as string);
          this.statusDropdown.selectedOption = statusOption;
          this.statusDropdown.cd.detectChanges();
        }
      }
    }
    
    // Repetition dropdown
    if (this.repetitionDropdown && this.repetitionFilter) {
      if (this.repetitions && this.repetitions.length > 0) {
        const repetitionOption = this.repetitions.find((r: any) => r.value === this.repetitionFilter);
        if (repetitionOption) {
          this.repetitionDropdown.value = this.repetitionFilter;
          this.repetitionDropdown.selectedOption = repetitionOption;
          this.repetitionDropdown.cd.detectChanges();
        }
      }
    }
    
    // Note: departmentFilter, followupFilter, selectedDepartment, selectedFollowUpPerson
    // fromDateFilter, endDateFilter are bound with [(ngModel)] so they will update automatically
  }

  //#endregion

  /**
   * filtering activity list based on show activity value
   */
  onShowActivityChanged(e: any, showAtivityDropDown: any) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const selectedValue = e?.value !== undefined ? e.value : e;

    if (selectedValue === '1') {
      this.activityFilterDto.myOwnActivity = false;
    } else if (selectedValue === '2') {
      this.activityFilterDto.myOwnActivity = true;
    }

    // Clear specific user filters as they are not needed
    delete this.activityFilterDto.executionUserId;
    delete this.activityFilterDto.followUpUserId;

    this.paginationRequest.pageNumber = 1;
    this.loadActivities(true);
  }

  /**
   * filtering activity list based on activity responsible value
   */
  activityResponsible() {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    if (this.selectedActivity === '1') {
      this.activityFilterDto.myOwnActivity = false;
    } else if (this.selectedActivity === '2') {
      this.activityFilterDto.myOwnActivity = true;
    }

    // Clear specific user filters as they are not needed
    delete this.activityFilterDto.executionUserId;
    delete this.activityFilterDto.followUpUserId;

    this.paginationRequest.pageNumber = 1;
    this.loadActivities(true);
  }

  /**
   * filtering activity list based on followup value
   */
  onFollowupSelected(event: any) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    // Handle dropdown selection event
    const selectedValue = event?.value || null;

    // Reset Show Activity filter to "all" when changing followup filter for business-level users
    this.resetShowActivityFilter();

    sessionStorage.setItem(
      'search_FollowupDev_ResponsibleForFollowup',
      selectedValue || ''
    );

    this.selectedFilters.followUp = selectedValue;
    this.activityFilterDto.followupPersonId = selectedValue || undefined;
    
    // Update selectedFollowUpPerson for metadata filter mapping
    this.selectedFollowUpPerson = selectedValue;

    this.paginationRequest.pageNumber = 1;
    this.loadActivities(true);
  }

  /**
   * clearing follow up person
   */
  onFollowupCleared() {
    // Reset Show Activity filter to "all" when clearing followup filter for business-level users
    this.resetShowActivityFilter();

    this.selectedFollowUpPerson = null;
    this.activityFilterDto.followupPersonId = undefined;
    this.selectedFilters.followUp = null;

    // For admin level, also clear the text filter
    if (BaseServices.roleId === '1') {
      this.followupFilter = undefined;
      this.activityFilterDto.followupPerson = undefined;
    }

    this.paginationRequest.pageNumber = 1;
    this.loadActivities(true);
  }

  /**
   * filtering activity list based on done on value
   */
  onDoneOnChanged(doneOnDropDown: Select) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const selectedValue = doneOnDropDown?.value !== undefined
      ? doneOnDropDown.value
      : doneOnDropDown?.selectedOption?.value;

    sessionStorage.setItem('search_FollowupAct_DoneOn', selectedValue || '');

    // Reset Show Activity filter to "all" when changing done on filter for business-level users
    this.resetShowActivityFilter();

    // Reset all date filters
    this.selectedFilters.DoneDateFrom = null;
    this.selectedFilters.DoneDateTo = null;
    this.activityFilterDto.doneDateFrom = undefined;
    this.activityFilterDto.doneDateTo = undefined;

    const now = new Date(); // current time with hours/seconds
    let futureSixMonths = this.addMonths(new Date(now), 6);
    let futureTwelveMonths = this.addMonths(new Date(now), 12);

    if (selectedValue === 4) {
      // EndDate > now && EndDate <= futureSixMonths
      this.activityFilterDto.doneDateFrom = now.toISOString(); // строго после текущего момента
      futureSixMonths.setHours(23, 59, 59, 999);
      this.activityFilterDto.doneDateTo = futureSixMonths.toISOString();
    } else if (selectedValue === 5) {
      // EndDate > now && EndDate <= futureTwelveMonths
      this.activityFilterDto.doneDateFrom = now.toISOString();
      futureTwelveMonths.setHours(23, 59, 59, 999);
      this.activityFilterDto.doneDateTo = futureTwelveMonths.toISOString();
    } else if (selectedValue === 2) {
      // EndDate < now && CompletedDate === null
      this.activityFilterDto.doneDateFrom = undefined;
      this.activityFilterDto.doneDateTo = now.toISOString(); // strictly before the current moment
    } else {
      // Reset all date filters
      this.activityFilterDto.doneDateFrom = undefined;
      this.activityFilterDto.doneDateTo = undefined;
    }

    this.paginationRequest.pageNumber = 1;
    this.loadActivities(true);
  }

  /**
   * filtering activity list based on business value
   * @param chooseBusiness {Select}
   */
  onBusinessChanged(chooseBusiness: Select) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const selectedLabel = chooseBusiness?.selectedOption?.label;

    // Reset Show Activity filter to "all" when changing business filter for business-level users
    this.resetShowActivityFilter();

    this.selectedFilters.businessName = selectedLabel !== 'Select' ? selectedLabel : null;
    this.activityFilterDto.businessName = selectedLabel && selectedLabel !== 'Select' ? selectedLabel : undefined;

    this.paginationRequest.pageNumber = 1;
    this.loadActivities(true);
  }

  /**
   * clearing business filter
   */
  onBusinessCleared() {
    // Reset Show Activity filter to "all" when clearing business filter for business-level users
    this.resetShowActivityFilter();

    this.selectedFilters.businessName = null;
    this.activityFilterDto.businessName = undefined;
    this.paginationRequest.pageNumber = 1;
    this.loadActivities(true);
  }

  /**
   * filtering activity list based on repetition value
   * @param repetition {Select}
   */
  onRepetitionChanged(repetition: Select) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const selectedValue = repetition?.value;
    const selectedLabel = repetition?.selectedOption?.label;

    // Reset Show Activity filter to "all" when changing repetition filter for business-level users
    if (BaseServices.roleId === '5') {
      this.showActivityFilter = 'all';
    }

    sessionStorage.setItem(
      'search_FollowupAct_Repetition',
      selectedLabel || ''
    );

    this.selectedFilters.repetition = selectedLabel !== 'Select' ? selectedLabel : null;
    this.activityFilterDto.repetitionId = selectedValue && selectedValue !== 'Select' ? selectedValue : undefined;

    this.paginationRequest.pageNumber = 1;
    this.loadActivities(true);
  }

  /**
   * Reset Show Activity filter to "all" for all business-level users (Editor, User, Guest)
   */
  private resetShowActivityFilter(): void {
    if (BaseServices.roleId === '3' || BaseServices.roleId === '5') {
      this.showActivityFilter = 'all';
      this.activityFilterDto.myOwnActivity = false;
      // Clear specific user filters as they are not needed
      delete this.activityFilterDto.executionUserId;
      delete this.activityFilterDto.followUpUserId;
    }
  }

  /**
   * Handle individual filter changes with proper value binding and debounce
   */
  onTextFilterChange(filterType: string, value: string) {

    // No in-flight guard here. Returning early while `loading` was true threw the
    // keystroke away, so clearing a filter mid-request left the list filtered by a
    // value no longer in the box. Concurrency is already handled: loadActivities
    // unsubscribes the previous request before issuing a new one.
    clearTimeout(this.filterDebounceTimer);
    this.filterDebounceTimer = setTimeout(() => {
      switch (filterType) {
        case 'no':
          this.noFilter = value && value.trim() !== '' ? value : undefined;
          this.activityFilterDto.activityNumber = this.noFilter;
          break;
        case 'businessName':
          this.businessNameFilter = value && value.trim() !== '' ? value : undefined;
          this.activityFilterDto.businessName = this.businessNameFilter;
          break;
        case 'title':
          this.titleFilter = value && value.trim() !== '' ? value : undefined;
          this.activityFilterDto.title = this.titleFilter;
          break;
        case 'department':
          this.departmentFilter = value && value.trim() !== '' ? value : undefined;
          this.activityFilterDto.department = this.departmentFilter;
          break;
        case 'followup':
          this.followupFilter = value && value.trim() !== '' ? value : undefined;
          // For admin level, set the followupPerson filter
          if (BaseServices.roleId === '1') {
            this.activityFilterDto.followupPerson = this.followupFilter;
          }
          break;
        case 'responsiblePerson':
          this.responsiblePersonFilter = value && value.trim() !== '' ? value : undefined;
          this.activityFilterDto.responsiblePerson = this.responsiblePersonFilter;
          break;
        case 'createdByName':
          this.createdByNameFilter = value && value.trim() !== '' ? value : undefined;
          this.activityFilterDto.createdByName = this.createdByNameFilter;
          break;
        case 'description':
          this.descriptionFilter = value && value.trim() !== '' ? value : undefined;
          this.activityFilterDto.description = this.descriptionFilter;
          break;
      }

      // Reset Show Activity filter to "all" when searching for business-level users
      this.resetShowActivityFilter();

      // Reset to first page and re‐load
      this.paginationRequest.pageNumber = 1;
      this.loadActivities(true);
    }, 500);
  }

  /**
   * selecting activity list based on user role
   */
  SelectedActivityList() {
    this.userrights = JSON.parse(BaseServices.getUserRights());
    if (this.userrights != null) {
      for (let i = 0; i < this.userrights.length; i++) {
        if (this.userrights[i].name == 'ADMINISTRATE_ACTIVITIES') {
          this.myactivity = this.userrights[i].isChecked;
        }
      }
    }
    if (BaseServices.roleId != '5') {
      this.loadActivities(true); // Show loading during initial load
      this.selectedActivity = '1';
    } else if (BaseServices.roleId === '5' && this.myactivity == true) {
      this.loadActivities(true); // Show loading during initial load
      this.selectedActivity = '1';
    } else {
      this.activityFilterDto.myOwnActivity = true;
      this.loadActivities(true); // Show loading during initial load
      this.selectedActivity = '2';
    }
  }

  /**
   * startdate calendar onselect event
   * @param event{any}
   */
  onStartDateChanged(event: any) {
    let date: Date | null = null;

    if (event instanceof Date) {
      date = event;
    }
    else if (event && event.jsdate instanceof Date) {
      date = event.jsdate;
    }

    // Reset Show Activity filter to "all" when changing start date for business-level users
    this.resetShowActivityFilter();

    if (date) {
      sessionStorage.setItem('search_FollowupAct_FromDate', date.toString());
      this.startDate = date.toLocaleDateString();
      this.activityFilterDto.deadlineFrom = date.toISOString();
      this.endDateOptions = this.setDateInput(
        this.endDateOptions,
        {
          date: {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate()
          },
          formatted: date.toLocaleDateString('en-GB'),
          epoc: Math.floor(date.getTime() / 1000),
          jsdate: date
        },
        'startDate'
      );
      this.paginationRequest.pageNumber = 1;
      this.loadActivities(true);
    } else {
      this.activityFilterDto.deadlineFrom = undefined;
      sessionStorage.removeItem('search_FollowupAct_FromDate');
      this.paginationRequest.pageNumber = 1;
      this.loadActivities(true);
    }
  }

  /**
   * Method for setting date range
   * @param dateConfig {{IMyDpOptions}}
   * @param event {{IMyDateModel}}
   * @param type {{string}}
   */
  setDateInput(
    dateConfig: any,
    event: Date | any,
    type: string
  ): any {
    let date: Date = null!;
    if (event instanceof Date) {
      date = new Date(event.getTime());
    } else if (event?.jsdate) {
      date = new Date(event.jsdate.getTime());
    }
    let dateOptions = HelperService.setDateRange(dateConfig, date, type);
    return dateOptions;
  }
  /**
   * enddate calendar onselect event
   * @param event {IMyDateModel}
   */
  onEndDateChanged(event: any) {
    let date: Date | null = null;

    if (event instanceof Date) {
      date = event;
    }
    else if (event && event.jsdate instanceof Date) {
      date = event.jsdate;
    }

    // Reset Show Activity filter to "all" when changing end date for business-level users
    this.resetShowActivityFilter();

    if (date) {
      sessionStorage.setItem('search_FollowupAct_EndDate', date.toString());
      this.endDate = date.toLocaleDateString();
      this.activityFilterDto.deadlineTo = date.toISOString();
      this.startDateOptions = this.setDateInput(
        this.startDateOptions,
        {
          date: {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate()
          },
          formatted: date.toLocaleDateString('en-GB'),
          epoc: Math.floor(date.getTime() / 1000),
          jsdate: date
        },
        'endDate'
      );
      this.paginationRequest.pageNumber = 1;
      this.loadActivities(true);
    } else {
      this.activityFilterDto.deadlineTo = undefined;
      sessionStorage.removeItem('search_FollowupAct_EndDate');
      this.paginationRequest.pageNumber = 1;
      this.loadActivities(true);
    }
  }

  /**
   * generating pdf
   */
  onSubmitTemplateBased(activity: any) {
    this.saveButtonClicked = true;
    this.loading = true;
    let role = BaseServices.roleId;
    let businessId = BaseServices.BusinessId;
    activity.Status = 7;
    activity.BusinessId = businessId ? businessId : 0;
    activity.ApplicationId = BaseServices.ApplicationId;
    activity.CreatedBy = BaseServices.UserId;
    if (this.isPortal) {
      let activityCount = 0;
      for (var i = 0; i <= this.selectedBusiness.length - 1; i++) {
        if (BaseServices.roleId == '2') {
          activity.BusinessId = this.selectedBusiness[i].value;
          this.subscriptions.push(
            this.activityService
              .add(activity, BaseServices.ApplicationId)
              .subscribe(
                res => {
                  if (res) {
                    if (activityCount == 0) {
                      this.notifications.success('UI_NOTIFICATIONS.SAVED');
                    }
                    activityCount++;
                    this.cancel();
                    this.refreshActivity();
                    this.saveButtonClicked = false;
                    this.loading = false;
                    this.selectedBusiness = [];
                  }
                },
                error => {
                  this.saveButtonClicked = false;
                },
                () => {
                  this.saveButtonClicked = false;
                }
              )
          );
        }
      }
      let count = 0;
      activity.Businesses = '';
      this.selectedBusiness.forEach(x => {
        activity.Businesses += count == 0 ? x.value : ',' + x.value;
        count++;
      });
      if (BaseServices.roleId === '1') {
        activity.BusinessId = this.currentBusinessId;
        this.selectedBusiness.push(activity.BusinessId);
      } else if (BaseServices.roleId >= '3') {
        activity.BusinessId = BaseServices.BusinessId;
        this.selectedBusiness.push(activity.BusinessId);
      }
    } else {
      this.subscriptions.push(
        this.activityService
          .add(activity, BaseServices.ApplicationId)
          .subscribe(
            res => {
              if (res) {
                this.notifications.success('UI_NOTIFICATIONS.SAVED');
                this.cancel();
                this.refreshActivity();
                this.saveButtonClicked = false;
              }
            },
            error => {
              this.saveButtonClicked = false;
            },
            () => {
              this.saveButtonClicked = false;
            }
          )
      );
    }

    if (role === '1') {
      activity.IsAdmin = true;
    } else {
      activity.IsAdmin = false;
    }
  }

  /**
   * filtering activity list based on status value
   * @param event {any}
   * @param statusDropdown {any}
   */
  onStatusChanged(event: any, statusDropdown?: any) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const selectedValue = event?.value !== undefined ? event.value : event;

    // Reset Show Activity filter to "all" when changing status for business-level users
    this.resetShowActivityFilter();

    this.activityFilterDto.status = selectedValue || undefined;
    this.paginationRequest.pageNumber = 1;

    this.loadActivities(true);
  }

  /**
   * filtering activity list based on department value
   * @param event {any}
   */
  onDepartmentChange(event: any) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    // Reset Show Activity filter to "all" when changing department filter for Editor role
    this.resetShowActivityFilter();

    // Check if vDepartment is properly initialized
    if (!this.vDepartment || this.vDepartment.length === 0) {
      return;
    }

    // Check if vDepartment has more than just "Select" option
    if (this.vDepartment.length === 1) {
      return;
    }

    // Find department object by id and get the name
    let departmentName: string | undefined;

    if (event && typeof event.value !== 'undefined' && event.value !== null) {
      const found = this.vDepartment.find(dep => dep.value === event.value);
      departmentName = found ? found.label : undefined;

      // Update the selected department
      this.selectedDepartment = event.value;

      // Validate departmentName
      if (!departmentName) {
        return;
      }
    } else {
      departmentName = undefined;
      this.selectedDepartment = null;
    }

    // Set the filter
    this.activityFilterDto.department = departmentName || undefined;

    // Rebuild metadata filter to include the new department selection
    this.buildMetadataFilterFromActivityFilters();

    // Reset to first page and reload with loading state
    this.paginationRequest.pageNumber = 1;
    this.loadActivities(true);
  }

  /**
   * Handle the change in the "Show Activity" filter for Editor role.
   * @param filterValue - The selected filter value ('all' or 'for me')
   */
  onShowActivityChange(filterValue: string) {
    this.showActivityFilter = filterValue;

    // Update the filter DTO based on selection
    if (filterValue === 'for me') {
      this.activityFilterDto.myOwnActivity = true;
    } else {
      this.activityFilterDto.myOwnActivity = false;
    }

    // Clear specific user filters as they are not needed
    delete this.activityFilterDto.executionUserId;
    delete this.activityFilterDto.followUpUserId;

    this.paginationRequest.pageNumber = 1;
    this.loadActivities(true);
  }

  /**
   * clearing department filter
   */
  onDepartmentCleared() {
    // Reset Show Activity filter to "all" when clearing department filter for Editor role
    this.resetShowActivityFilter();

    // Clear the selected department and filter
    this.selectedDepartment = null;
    this.activityFilterDto.department = undefined;

    // For admin level, also clear the text filter
    if (BaseServices.roleId === '1') {
      this.departmentFilter = undefined;
    }

    // Rebuild metadata filter to clear the department selection
    this.buildMetadataFilterFromActivityFilters();

    // Reset to first page and reload
    this.paginationRequest.pageNumber = 1;
    this.loadActivities(true);
  }
  /**
   * Toggle filter visibility
   */
  toggleFilters(): void {
    this.showFilters = !this.showFilters;
  }

  /**
   * Build metadata filter from main activity filters
   */
  private buildMetadataFilterFromActivityFilters(): void {
    this.metadataFilter = {};
    
    // Add selected year to metadata filter
    this.metadataFilter.year = this.selectedYear;
    
    // Map activity filters to metadata filters
    if (this.activityFilterDto.activityNumber) {
      this.metadataFilter.nr = this.activityFilterDto.activityNumber;
    }
    if (this.activityFilterDto.businessName) {
      this.metadataFilter.business = this.activityFilterDto.businessName;
    }
    if (this.activityFilterDto.title) {
      this.metadataFilter.title = this.activityFilterDto.title;
    }
    if (this.activityFilterDto.description) {
      this.metadataFilter.description = this.activityFilterDto.description;
    }
    if (this.activityFilterDto.responsiblePerson) {
      this.metadataFilter.responsiblePerson = this.activityFilterDto.responsiblePerson;
    }
    if (this.activityFilterDto.followupPerson) {
      this.metadataFilter.responsibleForFollowup = parseInt(this.activityFilterDto.followupPerson) || undefined;
    }
    if (this.activityFilterDto.status) {
      this.metadataFilter.status = parseInt(this.activityFilterDto.status) || undefined;
    }
    if (this.activityFilterDto.repetitionId) {
      this.metadataFilter.recurrence = this.activityFilterDto.repetitionId;
    }
    if (this.activityFilterDto.businessId) {
      this.metadataFilter.businessById = this.activityFilterDto.businessId;
    }

    // Map department filter
    if (BaseServices.roleId === '1') {
      // Admin level: use text filter (departmentFilter)
      if (this.departmentFilter) {
        this.metadataFilter.department = this.departmentFilter;
      }
    } else {
      // Portal/Business level: use dropdown selection (selectedDepartment)
      if (this.selectedDepartment !== null && this.selectedDepartment !== undefined) {
        this.metadataFilter.department = this.selectedDepartment.toString();
      }
    }

    // Map follow-up person dropdown filter
    if (this.selectedFollowUpPerson !== null) {
      this.metadataFilter.responsibleForFollowup = this.selectedFollowUpPerson;
    }

    // Map text filters from the main filter panel
    if (this.noFilter) {
      this.metadataFilter.nr = this.noFilter;
    }
    if (this.businessNameFilter) {
      this.metadataFilter.business = this.businessNameFilter;
    }
    if (this.titleFilter) {
      this.metadataFilter.title = this.titleFilter;
    }
    if (this.descriptionFilter) {
      this.metadataFilter.description = this.descriptionFilter;
    }
    if (this.responsiblePersonFilter) {
      this.metadataFilter.responsiblePerson = this.responsiblePersonFilter;
    }
    if (this.followupFilter) {
      this.metadataFilter.responsibleForFollowup = parseInt(this.followupFilter) || undefined;
    }

  }

  /**
   * Navigate to previous year
   */
  goToPreviousYear(): void {
    this.selectedYear = this.selectedYear - 1;
    this.isYearPaginationActive = true;
    this.buildMetadataFilterFromActivityFilters();
  }

  /**
   * Navigate to next year
   */
  goToNextYear(): void {
    this.selectedYear = this.selectedYear + 1;
    this.isYearPaginationActive = true;
    this.buildMetadataFilterFromActivityFilters();
  }

  /**
   * Reset to current year
   */
  resetToCurrentYear(): void {
    this.selectedYear = this.currentYear;
    this.isYearPaginationActive = false;
    this.buildMetadataFilterFromActivityFilters();
  }

  /**
   * Check if previous year navigation is available
   */
  canGoToPreviousYear(): boolean {
    return this.selectedYear > this.currentYear - 20; // Allow going back 10 years
  }

  /**
   * Check if next year navigation is available
   */
  canGoToNextYear(): boolean {
    return this.selectedYear < this.currentYear + 5; // Allow going forward 5 years
  }

  /**
   * Check if currently viewing current year
   */
  isCurrentYear(): boolean {
    return this.selectedYear === this.currentYear;
  }

  /**
   * Refresh data by clearing all filters and resetting to default state
   */
  refreshData(): void {
    this.loading = true;

    // Clear persisted filter state
    this.filterStateService.clearFilterState(this.FILTER_MODULE_KEY);

    // Clear all text filters
    this.noFilter = undefined;
    this.businessNameFilter = undefined;
    this.titleFilter = undefined;
    this.departmentFilter = undefined;
    this.followupFilter = undefined;
    this.descriptionFilter = undefined;
    this.responsiblePersonFilter = undefined;

    // Clear all selected filters
    this.selectedFilters = {
      topic: null,
      case: null,
      followUp: null,
      execution: null,
      department: null,
      businessName: null,
      repetition: null,
      DoneDateFrom: null,
      DoneDateTo: null
    };

    // Clear all dropdown selections
    this.selectedFollowUpPerson = null;
    this.selectedDepartment = null;
    this.repetitionFilter = null;
    this.doneOnFilter = null;
    this.fromDateFilter = null;
    this.endDateFilter = null;

    // Reset date filters
    this.startDate = undefined;
    this.endDate = undefined;

    // Clear sessionStorage items for deadline dates
    sessionStorage.removeItem('search_FollowupAct_FromDate');
    sessionStorage.removeItem('search_FollowupAct_EndDate');

    // Reset Show Activity filter
    this.showActivityFilter = 'all';

    // Clear activity filter DTO (explicitly clear deadline date properties)
    this.activityFilterDto = {};
    this.activityFilterDto.deadlineFrom = undefined;
    this.activityFilterDto.deadlineTo = undefined;
    this.activityFilterDto.doneDateFrom = undefined;
    this.activityFilterDto.doneDateTo = undefined;

    // Clear metadata filter
    this.metadataFilter = {};

    // Reset year pagination
    this.resetToCurrentYear();

    // Reset pagination to first page
    this.paginationRequest.pageNumber = 1;

    // Reset sorting to priority-based default
    this.paginationRequest.sortColumn = 'PriorityOrder';
    this.paginationRequest.sortDirection = 'ASC';

    // Clear table filters if table exists
    if (this.activityTable) {
      this.activityTable.clear();
    }

    // Clear input field values
    if (this.noFilterInput) {
      this.noFilterInput.nativeElement.value = '';
    }
    if (this.businessNameFilterInput) {
      this.businessNameFilterInput.nativeElement.value = '';
    }
    if (this.titleFilterInput) {
      this.titleFilterInput.nativeElement.value = '';
    }
    if (this.departmentFilterInput) {
      this.departmentFilterInput.nativeElement.value = '';
    }
    if (this.descriptionFilterInput) {
      this.descriptionFilterInput.nativeElement.value = '';
    }
    if (this.followupFilterInput) {
      this.followupFilterInput.nativeElement.value = '';
    }
    
    // Reset dropdown values
    if (this.statusDropdown) {
      this.statusDropdown.value = null;
      this.statusDropdown.cd.detectChanges();
    }
    if (this.repetitionDropdown) {
      this.repetitionDropdown.value = null;
      this.repetitionDropdown.cd.detectChanges();
    }
    
    // Reload activities with cleared filters
    this.loadActivities(true);
  }

  /**
   * Clear all sorting and reset to priority-based default
   */
  clearSorting(): void {
    this.paginationRequest.sortColumn = 'PriorityOrder';
    this.paginationRequest.sortDirection = 'ASC';
    this.paginationRequest.pageNumber = 1;
    this.loadActivities(true);
  }

  /**
   * Apply priority-based sorting for activities
   * This ensures consistent ordering across all user levels:
   * 1. NEW status (newest first)
   * 2. OPEN status (oldest deadline first - most urgent)
   * 3. DONE status (newest first)
   * 4. REJECTED status (newest first)
   */
  private applyPrioritySorting(): void {
    // Set special sorting column for priority-based ordering
    this.paginationRequest.sortColumn = 'PriorityOrder';
    this.paginationRequest.sortDirection = 'ASC';

    // Debug logging for priority sorting
  }

  /**
   * Get the count of active filters
   * @returns number of active filters
   */
  getActiveFiltersCount(): number {
    let count = 0;

    // Text filters
    if (this.noFilter) count++;
    if (this.businessNameFilter) count++;
    if (this.titleFilter) count++;
    if (this.departmentFilter && this.isAdmin) count++;
    if (this.followupFilter && this.isAdmin) count++;
    if (this.descriptionFilter) count++;
    if (this.responsiblePersonFilter) count++;

    // Dropdown filters
    if (this.activityFilterDto.status) count++;
    if (this.activityFilterDto.repetitionId) count++;
    if (this.selectedDepartment && !this.isAdmin) count++;
    if (this.selectedFollowUpPerson && !this.isAdmin) count++;

    // Date filters
    if (this.activityFilterDto.doneDateFrom) count++;
    if (this.activityFilterDto.doneDateTo) count++;
    if (this.activityFilterDto.deadlineFrom) count++;
    if (this.activityFilterDto.deadlineTo) count++;

    // Show Activity filter (only count if not showing all)
    if (this.showActivityFilter && this.showActivityFilter !== 'all' && this.showActivityFilter !== '1') count++;

    return count;
  }

  //#endregion
  //#region methods
  /**
   * binding all dropdowns
   * @param businessId {number}
   */
  bindDetails(businessId: any) {
    this.vresperson = [];
    let responsiblePerson: any[];
    responsiblePerson = this.route.snapshot.data['users'];
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.vresperson = [];
        this.vresperson.push({ label: val.SELECT, value: null });
      })
    );
    if (responsiblePerson) {
      responsiblePerson.forEach((responblePerson: any) => {
        this.vresperson.push({
          label: responblePerson.Name,
          value: responblePerson.Id
        });
      });
    }

    this.follows = [];
    let followUpPerson: any[];
    followUpPerson = this.route.snapshot.data['user'];
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.follows = [];
        this.follows.push({ label: val.SELECT, value: null });
        if (followUpPerson) {
          followUpPerson.forEach((followupPerson: any) => {
            this.follows.push({
              label: followupPerson.Name,
              value: followupPerson.Id
            });
          });
        }
      })
    );
    this.subscriptions.push(
      this.translate.stream('REPETITION_LIST').subscribe(val => {
        this.repetitions = [];
        this.repetitions.push(
          { label: val.REPETITION_LIST_SELECT, value: null },
          { label: val.REPETITION_LIST_NO_REPETITION, value: 1 },
          { label: val.REPETITION_LIST_DAILY, value: 2 },
          { label: val.REPETITION_LIST_WEEKDAYS, value: 3 },
          { label: val.REPETITION_LIST_EVERY_WEEK, value: 4 },
          { label: val.REPETITION_LIST_EVERY_2_WEEKS, value: 5 },
          { label: val.REPETITION_LIST_EVERY_3_WEEKS, value: 6 },
          { label: val.REPETITION_LIST_EVERY_6_WEEKS, value: 22 },
          { label: val.REPETITION_LIST_EVERY_MONTH, value: 7 },
          { label: val.REPETITION_LIST_EVERY_2_MONTH, value: 8 },
          { label: val.REPETITION_LIST_EVERY_3_MONTH, value: 9 },
          { label: val.REPETITION_LIST_EVERY_4_MONTH, value: 10 },
          { label: val.REPETITION_LIST_EVERY_6_MONTH, value: 11 },
          { label: val.REPETITION_LIST_EVERY_YEAR, value: 12 },
          { label: val.REPETITION_LIST_EVERY_2_YEARS, value: 13 },
          { label: val.REPETITION_LIST_EVERY_3_YEARS, value: 14 },
          { label: val.REPETITION_LIST_EVERY_4_YEARS, value: 15 },
          { label: val.REPETITION_LIST_EVERY_5_YEARS, value: 16 },
          { label: val.REPETITION_LIST_EVERY_6_YEARS, value: 17 },
          { label: val.REPETITION_LIST_EVERY_7_YEARS, value: 18 },
          { label: val.REPETITION_LIST_EVERY_8_YEARS, value: 19 },
          { label: val.REPETITION_LIST_EVERY_9_YEARS, value: 20 },
          { label: val.REPETITION_LIST_EVERY_10_YEARS, value: 21 }
        );
      })
    );

    this.vDepartment = [];
    let departments: any[];
    departments = this.route.snapshot.data['departments'];

    // Initialize with "Select" option first
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.vDepartment = [];
        this.vDepartment.push({ label: val.SELECT, value: null });

        // Add departments after translation is loaded
        if (departments && Array.isArray(departments)) {
          departments.forEach((department: any) => {
            if (department && department.Name && department.Id) {
              this.vDepartment.push({
                label: department.Name,
                value: department.Id
              });
            }
          });
        }
      })
    );
    this.subscriptions.push(
      this.translate.stream('SELECT_STATUSES').subscribe(val => {
        this.statuses = [];
        this.statuses.push(
          { label: val.SELECT, value: null },
          { label: val.NEW, value: 7 },
          { label: val.OPEN, value: 8 },
          { label: val.DONE, value: 9 },
          { label: val.REJECTED, value: 10 }
        );
      })
    );
    this.subscriptions.push(
      this.translate.stream('ACTIVITY_DONE_DROPDOWN').subscribe(val => {
        this.doneOn = [];
        this.doneOn.push(
          { label: val.ALL, value: 0 },
          { label: val.NOTICE_PERIOD, value: 1 },
          { label: val.OVERDEADLINE, value: 2 },
          { label: val.TIME_REMAIN, value: 3 },
          { label: val.UP_SIX_MONTH, value: 4 },
          { label: val.UP_TWELEVE_MONTH, value: 5 },
          { label: val.DONE_ON, value: 6 }
        );
        this.showActivities = [];
        this.showActivities.push({ label: val.ALL, value: '1' });
        this.showActivities.push({
          label: this.translate.instant('MYACTIVITY'),
          value: '2'
        });
      })
    );

  }

  /**
   * deleting activity by id
   * @param id {any}
   */
  confirm(id: any) {
    this.subscriptions.push(
      this.activityService.checkParentActivity(id).subscribe((count: any) => {
        // check for normal activity or child activity
        if (count === 0 || count === 2) {
          this.confirmationService.confirm({
            message: this.translate.instant('DELETE_THIS_RECORD'),
            accept: () => {
              this.loading = true;
              this.subscriptions.push(
                this.activityService
                  .delete(id)
                  .subscribe({
                    next:isRecurringActivityDeleted => {
                      if (isRecurringActivityDeleted) {
                        this.notifications.success('UI_NOTIFICATIONS.DELETED');
                        this.refreshActivity();
                        this.loading = false;
                      }
                    },
                    error:error => {
                      this.loading = false;
                    }
                  })
              );
            }
          });
        } else {
          // parent activity delete
          this.confirmationService.confirm({
            message: this.translate.instant('DELETE_PARENT_ACTIVITY'),
            accept: () => {
              this.loading = true;
              this.subscriptions.push(
                this.activityService
                  .deleteParentwithRecurring(id)
                  .subscribe(isActivityDeleted => {
                    if (isActivityDeleted) {
                      this.notifications.success('UI_NOTIFICATIONS.DELETED');
                      this.refreshActivity();
                      this.loading = false;
                    }
                  })
              );
            }
          });
        }
      })
    );
  }
  /**
   * binding list
   */
  refreshActivity() {
    // Use the new loadActivities method which properly handles loading states
    this.loadActivities(true);
  }

  /**
   * binding business list
   */
  bindBusiness() {
    this.businesses = [];

    const business = this.route.snapshot.data['business'];

    // Add "Select" option for resetting the filter and populate businesses
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.businesses = [];
        this.businesses.push({ label: val.SELECT, value: null });

        // Populate businesses inside the subscription to ensure proper timing
        if (Array.isArray(business)) {
          business.forEach(element => {
            // Handle both old (/activebusinesses) and new (/businesses/names) data structures
            if (element && element.Features != null) {
              // Old structure: check features for activity permissions
              try {
                const feature = JSON.parse(element.Features);
                if (Array.isArray(feature)) {
                  feature.forEach(featureItem => {
                    if (
                      featureItem &&
                      featureItem.id === FeatureKey.FOLLOW_UP &&
                      featureItem.children
                    ) {
                      const isActivity = featureItem.children.find(
                        x => x.id === FeatureKey.ACTIVITIES
                      );
                      if (isActivity && isActivity.checked) {
                        this.businesses.push({
                          label: element.Name,
                          value: element.Id
                        });
                      }
                    }
                  });
                }
              } catch (error) {
              }
            } else if (element && element.Name && element.Id) {
              // New structure: direct Name/Id mapping (from /businesses/names endpoint)
              // For admin and portal levels, we trust the endpoint to return only relevant businesses
              if (BaseServices.roleId === '1' || BaseServices.roleId === '2') {
                this.businesses.push({
                  label: element.Name,
                  value: element.Id
                });
              }
            }
          });
        }
      })
    );
  }
  /**
   * checking if business is selected
   */
  BusinessCount() {
    if (this.isPortal) {
      this.showSave = this.selectedBusiness.length > 0 ? true : false;
    }
  }

  /**
   * saving portal activity
   */
  savePortalActivity() {
    this.loading = true;
    this.confirmationService.confirm({
      message: this.translate.instant('DELETION_OF_ACTIVITY'),
      accept: () => {
        this.onSubmitTemplateBased(this.newActivityForm.value);
      }
    });
  }

  /**
   * adding months to date
   * @param date {any}
   * @param months {any}
   */
  addMonths(date: any, months: any) {
    date.setMonth(date.getMonth() + months);
    return date;
  }
  /**
   * getting days diffrence between start date and end date
   * @param StartDate {date}
   * @param EndDate {date}
   */
  getDaysDiff(StartDate: Date, EndDate: Date) {
    if (StartDate && EndDate) {
      let _MS_PER_DAY = 1000 * 60 * 60 * 24;
      let date1 = Date.UTC(
        StartDate.getFullYear(),
        StartDate.getMonth(),
        StartDate.getDate()
      );
      let date2 = Date.UTC(
        EndDate.getFullYear(),
        EndDate.getMonth(),
        EndDate.getDate()
      );
      let res: any = Math.floor((date2 - date1) / _MS_PER_DAY);
      return res;
    }
  }
  /**
   * show all list
   */
  showAll() {
    // Use the new loadActivities method which properly handles loading states
    // Reset filters to show all activities
    this.activityFilterDto = {};
    this.paginationRequest.pageNumber = 1;
    this.loadActivities(true);
  }
  /**
   * bind activity by User Id
   */
  bindActitvityByUser() {
    this.activityFilterDto.myOwnActivity = true;
    this.loadActivities(true);
  }
  /**
   * edit the activity page based upon the rights
   */
  onAdministrateActivity() {
    let currentUserRole = BaseServices.UserRole;
    let userRightsId = Rights.ADMINISTRATE_ACTIVITIES;
    if (currentUserRole === 'User') {
      this.isAdministrateActivity = BaseServices.checkUserRights(
        userRightsId,
        currentUserRole
      );
    } else if (currentUserRole === 'Guest') {
      this.isAdministrateActivity = false;
    } else {
      this.isAdministrateActivity = true;
    }
  }
  /**
   * get current date
   */
  getCurrentDate() {
    let dateFormat = new Date();
    return {
      year: dateFormat.getFullYear(),
      month: dateFormat.getMonth() + 1,
      day: dateFormat.getDate() + 1
    };
  }

  /**
   * paging the activity list
   * @param event {LazyLoadEvent}
   */
  onPage(event: LazyLoadEvent) {
    this.paginationRequest.pageNumber = (event.first! / event.rows!) + 1;
    this.paginationRequest.pageSize = event.rows!;
    this.loadActivities(true); // Show loading during page change
  }

  /**
   * sorting the activity list
   * @param event {SortEvent}
   */
  onSort(event: SortEvent) {
    const sortField = event.field;
    const sortOrder = event.order;

    const mappedColumn = this.columnMapping[sortField];

    if (mappedColumn) {
      // If sorting by a specific column, use that; otherwise use priority sorting
      if (mappedColumn === 'PriorityOrder') {
        this.applyPrioritySorting();
      } else {
        this.paginationRequest.sortColumn = mappedColumn;
        this.paginationRequest.sortDirection = sortOrder === 1 ? 'ASC' : 'DESC';
        this.validateSorting();
      }

      this.paginationRequest.pageNumber = 1;
      this.loadActivities(true); // Show loading during sort
    }

  }

  /**
   * Validates and cleans the sorting parameters
   */
  private validateSorting(): void {
    const validSortColumns = ['No', 'Title', 'BusinessName', 'ExecutionUserList', 'FollowupUserList', 'Deadline', 'CreatedOn', 'DoneOn', 'PriorityOrder', 'Status', 'ActivityNumber', 'CompanyName', 'EndDate', 'CompletedDate'];

    if (this.paginationRequest.sortColumn && !validSortColumns.includes(this.paginationRequest.sortColumn)) {
      this.paginationRequest.sortColumn = 'PriorityOrder';
    }

    if (this.paginationRequest.sortDirection && !['ASC', 'DESC'].includes(this.paginationRequest.sortDirection)) {
      this.paginationRequest.sortDirection = 'ASC';
    }
  }

  /**
   * filtering the activity list
   * @param event {any}
   */
  onFilter(event: any) {
    // Reset Show Activity filter to "all" when filtering for Editor role
    this.resetShowActivityFilter();

    // whenever a column filter fires, grab its value:
    if (event.column?.field && event.filters[event.column.field]) {
      this.activityFilterDto[event.column.field] = event.filters[event.column.field].value || undefined;
    }
    this.paginationRequest.pageNumber = 1;
    this.loadActivities(true); // Show loading during filter
  }

  /**
   * deleting the activity
   * @param activity {any}
   */
  deleteActivity(activity: any) {
    activity.Status = 0;
    this.subscriptions.push(
      this.activityService.deleteactivity(activity).subscribe(isDeleted => {
        if (isDeleted) {
        }
      })
    );
  }
  //#endregion

  /**
   * show new activity pop-up
   */
  showDialogToAdd() {
    this.displayDialog = true;
  }

  /**
   * Navigate to new portal activity page
   */
  goToNewPortalActivity() {
    this.router.navigate(['./portal-activity-new'], { relativeTo: this.route });
  }

  /**
   * close new activity pop-up
   */
  cancel() {
    this.newActivityForm = this._fb.group({
      Status: this.newActivityTitle,
      Title: ['', Validators.required],
      Description: ['']
    });
    this.displayDialog = false;
  }
  /**
   * popup close event
   */
  onCloseEvent() {
    this.newActivityForm = this._fb.group({
      Status: this.newActivityTitle,
      Title: ['', Validators.required],
      Description: ['']
    });
  }
  /**
   * show dialog for stop future recurring activity
   */
  showDialogForStopFutureRecurring(data: any) {
    this.displayDialogForRecurring = true;
    this.recurringActivityId = data.Id;
    this.IsFutureRecurring = data.IsFutureRecurring
      ? data.IsFutureRecurring
      : false;
  }
  /**
   * stops the chain from rucurring
   */
  onClickStopFutureRecurring() {
    if (this.recurringActivityId > 0) {
      this.displayDialogForRecurring = false;
      this.loading = true;
      this.subscriptions.push(
        this.activityService
          .stopFutureRecurring(this.recurringActivityId)
          .subscribe(result => {
            if (result) {
              this.notifications.success('UI_NOTIFICATIONS.RECURRENCE_STOPPED');
              this.refreshActivity();
              this.loading = false;
            }
          })
      );
    }
  }

  /**
   * deleting the recurring activity
   */
  onClickDeleteRecurringActivity() {
    if (this.recurringActivityId > 0) {
      this.subscriptions.push(
        this.activityService
          .checkParentActivity(this.recurringActivityId)
          .subscribe((count: any) => {
            // check for normal activity or child activity
            if (count === 0 || count === 2) {
              this.loading = true;
              this.subscriptions.push(
                this.activityService
                  .delete(this.recurringActivityId)
                  .subscribe(isRecurringActivityDeleted => {
                    if (isRecurringActivityDeleted) {
                      this.notifications.success('UI_NOTIFICATIONS.DELETED');
                      this.refreshActivity();
                      this.loading = false;
                    }
                  })
              );
            } else {
              this.loading = true;
              this.subscriptions.push(
                this.activityService
                  .deleteParentwithRecurring(this.recurringActivityId)
                  .subscribe(isActivityDeleted => {
                    if (isActivityDeleted) {
                      this.notifications.success('UI_NOTIFICATIONS.DELETED');
                      this.refreshActivity();
                      this.loading = false;
                    }
                  })
              );
            }
          })
      );
      this.displayDialogForRecurring = false;
    }
  }

  /**
   * concatenating employee name
   * @param responsibleList {any}
   * @param actId {number}
   * @param status {string}
   */
  concatenateEmployeeName(responsibleList: any, actId: number, status: string) {
    let userName = '';
    if (status !== 'NEW') {
      let userList = responsibleList
        .filter((x: any) => x.ActivityId === actId)
        .map(({ Name }: any) => Name);
      if (userList.length > 0) {
        userName = userList.join(', ');
      }
    }
    return userName;
  }

  /**
   * binding status icon
   * @param activityList {any}
   */
  bindStatusIcon(activityList: any) {
    this.activityList = [];
    if (activityList) {
      activityList.forEach((activityInfo: any) => {
        activityInfo.Responsible =
          activityInfo.FollowupUserIdList?.some((id: number) => id === BaseServices.UserId) ||
          activityInfo.ExecutionUserIdList?.some((id: number) => id === BaseServices.UserId) ||
          activityInfo.CreatedBy === BaseServices.UserId;

        this.activityList.push(activityInfo);
      });

      this.rowsPerPageOptions = [10, 20, 50, 100];
      if (this.activityList.length > 100) {
        this.rowsPerPageOptions.push(this.activityList.length);
      }
    }
  }

  /**
   * loading the activity list
   * @param showSpinner {boolean}
   */
  private loadActivities(showSpinner = false) {
    // Always set loading to true when starting to fetch data
    this.loading = true;
    this.isLoadingData = true;

    // Build metadata filter from current activity filters
    this.buildMetadataFilterFromActivityFilters();

    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const businessId = BaseServices.BusinessId || 0;
    const portalId = BaseServices.PortalId || 0;

    // Apply priority-based sorting if no specific sorting is requested
    if (!this.paginationRequest.sortColumn || this.paginationRequest.sortColumn === 'PriorityOrder') {
      this.applyPrioritySorting();
    }

    // Apply Show Activity filter for all business-level users (Editor, User, Guest)
    if ((BaseServices.roleId === '3' || BaseServices.roleId === '5') && this.showActivityFilter === 'for me') {
      // For business-level users, when "for me" is selected, get activities where user is responsible
      this.activityFilterDto.myOwnActivity = true;
      // Clear specific user filters as they are not needed
      delete this.activityFilterDto.executionUserId;
      delete this.activityFilterDto.followUpUserId;
    } else {
      // When "all" is selected or for other roles, set myOwnActivity to false
      this.activityFilterDto.myOwnActivity = false;
      // Clear specific user filters as they are not needed
      delete this.activityFilterDto.executionUserId;
      delete this.activityFilterDto.followUpUserId;
    }

    let dataObservable: Observable<PagedResponse<any>>;

    if (BaseServices.roleId === '1') {
      dataObservable = this.activityService.getAdminActivityListPaged(
        this.paginationRequest,
        this.activityFilterDto
      );
    } else if (BaseServices.roleId === '2') {
      dataObservable = this.activityService.getActivityListPagedByPortalId(
        this.paginationRequest,
        this.activityFilterDto
      );
    } else {
      dataObservable = this.activityService.getActivityListPagedByBusinessId(
        this.paginationRequest,
        this.activityFilterDto,
        businessId
      );
    }

    this.loadingSubscription = dataObservable.subscribe(
      (response: PagedResponse<any>) => {
        if (response == null) {
          this.activityList = [];
          this.totalRecords = 0;
          this.totalPages = 0;
          this.isLoadingData = false;
          this.loading = false;
          return;
        }
        this.handleActivityResponse(response);
        
        // Save filter state after successful load
        this.saveFilterStateToStorage();
        
        this.isLoadingData = false;
        this.loading = false;
      },error => {
        this.isLoadingData = false;
        this.loading = false;
        // Handle error - you might want to show an error message
        this.activityList = [];
        this.totalRecords = 0;
        this.totalPages = 0;
      }
    );
  }

  /**
   * handling the activity response
   * @param response {PagedResponse<any>}
   */
  private handleActivityResponse(response: PagedResponse<any>) {

    if (response != null && response.Succeeded) {
      const processedList: any[] = response.Items;

      this.bindStatusIcon(processedList);

      this.activityList = processedList;
      this.totalRecords = response.TotalCount;
      this.totalPages = response.TotalPages;
      this.paginationRequest.pageNumber = response.PageNumber;
      this.paginationRequest.pageSize = response.PageSize;

      if (Boolean(response.Metadata)) {
        this.activityListMetadata = response.Metadata;
      } else {
        this.activityListMetadata = null;

      }
      this.bindDetails(this.activityList);

      // Update selection state after loading new data
      this.updateSelectAllState();

      if (this.activityTable) {
        const firstIndex =
          (this.paginationRequest.pageNumber - 1) *
          this.paginationRequest.pageSize;
        this.activityTable.first = firstIndex;
      } else {
        return;
      }

    }
  }

  /**
   * destroying the component
   */
  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });

    // Clear export dialog timeout
    if (this.exportDialogTimeout) {
      clearTimeout(this.exportDialogTimeout);
      this.exportDialogTimeout = null;
    }
  }

  /**
   * Show export loader with 2 second delay
   */
  showExportLoader() {
    this.loading = true;
    // Start a 2s timer to show the dialog only if still loading
    this.exportDialogTimeout = setTimeout(() => {
      this.exportInProgress = true;
    }, 2000);
  }

  /**
   * Hide export loader and clear timer
   */
  hideExportLoader() {
    this.loading = false;
    // Always clear the timer
    if (this.exportDialogTimeout) {
      clearTimeout(this.exportDialogTimeout);
      this.exportDialogTimeout = null;
    }
    this.exportInProgress = false;
  }

  /**
   * Truncate person list to show only first few names with ellipsis
   * @param personList - Comma-separated list of person names
   * @param maxNames - Maximum number of names to show (default: 2)
   * @returns Truncated person list string
   */
  truncatePersonList(personList: string, maxNames: number = 2): string {
    if (!personList || personList.trim() === '') {
      return '';
    }

    const names = personList.split(',').map(name => name.trim()).filter(name => name);
    
    if (names.length <= maxNames) {
      return personList;
    }

    const visibleNames = names.slice(0, maxNames);
    const remainingCount = names.length - maxNames;
    
    return `${visibleNames.join(', ')} +${remainingCount}...`;
  }

  /**
   * Get all activities for export with filters and sorting
   * @returns Promise with all activities for export
   */
  getAllActivitiesForExport = (): Promise<any[]> => {

    // Ensure myOwnActivity is properly set based on current filter state
    if (this.showActivityFilter === 'for me') {
      this.activityFilterDto.myOwnActivity = true;
    } else {
      this.activityFilterDto.myOwnActivity = false;
    }


    // Create export request with current pagination and sorting
    const exportRequest = {
      pageNumber: 1,
      pageSize: 100000, // maximum possible
      sortColumn: this.paginationRequest.sortColumn,
      sortDirection: this.paginationRequest.sortDirection
    };

    // Create filter DTO for export
    const exportFilter = {
      ...this.activityFilterDto
      // Add any additional filters that might be needed for export
    };


    let serviceCall: Observable<any[]>;

    if (BaseServices.roleId === '1') {
      // Admin users
      serviceCall = this.activityService.getAllActivitiesForExportAdmin(exportRequest, exportFilter);
    } else if (BaseServices.roleId === '2') {
      // Portal users
      serviceCall = this.activityService.getAllActivitiesForExportPortal(exportRequest, exportFilter);
    } else {
      // Business users
      serviceCall = this.activityService.getAllActivitiesForExport(BaseServices.BusinessId, exportRequest, exportFilter);
    }

    return new Promise((resolve, reject) => {
      serviceCall.subscribe({
        next:result => resolve(result || []),
        error:err => reject(err)
      });
    });
  };

  //#region Multi-select methods - using same approach as employee table

  /**
   * Handle individual activity selection change
   * @param event Selection event from PrimeNG checkbox
   */
  onActivitySelectionChange(event: any) {
    if (event.checked) {
      // Add to global selection
      this.allSelectedActivities.add(event.data.Id);
      // Also add to recurring selection if it's a recurring activity
      if (this.isActivityRecurring(event.data)) {
        this.allSelectedRecurringActivities.add(event.data.Id);
      }
      // Reset the flag when new activities are selected
      this.justStoppedRecurrence = false;
    } else {
      // Remove from global selection
      this.allSelectedActivities.delete(event.data.Id);
      // Also remove from recurring selection
      this.allSelectedRecurringActivities.delete(event.data.Id);
    }

    // Update the selectedActivities array for current page
    this.selectedActivities = this.activityList.filter((activity: ActivityListDto) =>
      this.allSelectedActivities.has(activity.Id)
    );
    
    this.updateSelectAllState();
  }

  /**
   * Handle select all checkbox change (select all on current page)
   * @param event Selection event from PrimeNG checkbox
   */
  onSelectAllChange(event: any) {
    this.isAllSelected = event.checked;

    if (event.checked) {
      // Select all activities on current page that are not "Done" (StatusId !== 9)
      this.activityList.forEach((activity: ActivityListDto) => {
        if (activity.StatusId !== 9) {
          this.allSelectedActivities.add(activity.Id);
          // Also add to recurring selection if it's a recurring activity
          if (this.isActivityRecurring(activity)) {
            this.allSelectedRecurringActivities.add(activity.Id);
          }
        }
      });
      // Reset the flag when new activities are selected
      this.justStoppedRecurrence = false;
    } else {
      // Deselect all activities on current page
      this.activityList.forEach((activity: ActivityListDto) => {
        this.allSelectedActivities.delete(activity.Id);
        this.allSelectedRecurringActivities.delete(activity.Id);
      });
    }

    // Update the selectedActivities array
    this.selectedActivities = this.activityList.filter((activity: ActivityListDto) =>
      this.allSelectedActivities.has(activity.Id)
    );
    
    this.updateSelectAllState();
  }

  /**
   * Check if activity is selected
   * @param activity - Activity to check
   * @returns true if activity is selected
   */
  isActivitySelected(activity: ActivityListDto): boolean {
    return this.allSelectedActivities.has(activity.Id);
  }

  /**
   * Check if all activities on current page are selected
   */
  isAllSelectedOnCurrentPage(): boolean {
    if (this.activityList.length === 0) return false;
    const selectableActivities = this.activityList.filter(activity => activity.StatusId !== 9);
    if (selectableActivities.length === 0) return false;
    return selectableActivities.every((activity: ActivityListDto) =>
      this.allSelectedActivities.has(activity.Id)
    );
  }

  /**
   * Update select all checkbox state based on current selection
   */
  updateSelectAllState() {
    this.isAllSelected = this.isAllSelectedOnCurrentPage();
  }

  /**
   * Clear all selected activities
   */
  clearSelection() {
    this.allSelectedActivities.clear();
    this.allSelectedRecurringActivities.clear();
    this.selectedActivities = [];
    this.isAllSelected = false;
  }

  /**
   * Clear all selections (useful when filters change)
   */
  clearAllSelections() {
    this.allSelectedActivities.clear();
    this.allSelectedRecurringActivities.clear();
    this.selectedActivities = [];
    this.isAllSelected = false;
  }

  /**
   * Check if selected activities can be deleted
   * @returns true if all selected activities can be deleted
   */
  get canDeleteSelected(): boolean {
    return ( this.allSelectedActivities.size > 0 &&
      this.selectedActivities.every(activity => activity.StatusId !== 9));
  }

  /**
   * Check if selected activities can have recurrence stopped
   * @returns true if at least one selected activity has active recurrence
   */
  get canStopRecurrenceSelected(): boolean {
    if (this.allSelectedActivities.size === 0) {
      return false;
    }
    
    // If we just stopped recurrence, disable the button
    if (this.justStoppedRecurrence) {
      return false;
    }
    
    // Always check the tracked recurring activities set first
    // This ensures consistency across pages and after operations
    if (this.allSelectedRecurringActivities.size > 0) {
      return true;
    }
    
    // If no recurring activities are tracked, check current page as fallback
    // This handles cases where activities might not be properly tracked
    const hasRecurringOnCurrentPage = this.selectedActivities.some(activity => this.isActivityRecurring(activity));
    return hasRecurringOnCurrentPage;
  }

  /**
   * Get tooltip text for activity checkbox showing if it's recurring
   * @param activity The activity to check
   * @returns Tooltip text
   */
  getActivityRecurringTooltip(activity: ActivityListDto): string {
    if (this.isActivityRecurring(activity)) {
      return this.translate.instant('RECURRING_ACTIVITY');
    } else if (activity.RepetitionId > 1 && activity.IsFutureRecurring === true) {
      return this.translate.instant('RECURRING_ACTIVITY_STOPPED');
    } else {
      return this.translate.instant('NON_RECURRING_ACTIVITY');
    }
  }

  /**
   * Check if an activity is recurring
   * @param activity The activity to check
   * @returns true if the activity is recurring and future recurrence is still active
   */
  isActivityRecurring(activity: ActivityListDto): boolean {
    // Activity is recurring if:
    // 1. RepetitionId > 1 (has a recurring pattern)
    // 2. IsFutureRecurring is false or null (future recurrence is still active)
    return ( activity.RepetitionId > 1 && (activity.IsFutureRecurring === false || activity.IsFutureRecurring === null));
  }

  /**
   * Get count of recurring activities in selected activities across all pages
   * @returns Number of recurring activities selected
   */
  getSelectedRecurringCount(): number {
    return this.allSelectedRecurringActivities.size;
  }

  /**
   * Get tooltip text for stop recurrence button
   * @returns Tooltip text explaining button state
   */
  getStopRecurrenceTooltip(): string {
    if (this.allSelectedActivities.size === 0) {
      return this.translate.instant('SELECT_ACTIVITIES_TO_STOP_RECURRENCE');
    }
    
    // If we just stopped recurrence, show appropriate message
    if (this.justStoppedRecurrence) {
      return this.translate.instant('SELECTED_ACTIVITIES_NOT_RECURRING');
    }
    
    // Always check the tracked recurring activities set first
    if (this.allSelectedRecurringActivities.size > 0) {
      return this.translate.instant('STOP_RECURRENCE_READY');
    }
    
    // If no recurring activities are tracked, check current page as fallback
    const hasRecurringOnCurrentPage = this.selectedActivities.some(activity => this.isActivityRecurring(activity));
    if (hasRecurringOnCurrentPage) {
      return this.translate.instant('STOP_RECURRENCE_READY');
    } else {
      return this.translate.instant('SELECTED_ACTIVITIES_NOT_RECURRING');
    }
  }

  /**
   * Confirm multi-delete action
   */
  confirmMultiDelete() {
    this.confirmationService.confirm({
      message: this.translate.instant('CONFIRM_MULTI_DELETE'),
      accept: () => {
        this.multiDeleteActivities();
      }
    });
  }

  /**
   * Confirm multi-stop recurrence action
   */
  confirmMultiStopRecurrence() {
    const recurringCount = this.getSelectedRecurringCount();
    const totalCount = this.allSelectedActivities.size;
    
    let message: string;
    
    if (recurringCount < totalCount) {
      // Use a combined message when not all activities are recurring
      message = this.translate.instant('CONFIRM_MULTI_STOP_RECURRENCE_WITH_WARNING')
        .replace('{count}', recurringCount.toString())
        .replace('{recurring}', recurringCount.toString())
        .replace('{total}', totalCount.toString());
    } else {
      // Use simple message when all activities are recurring
      message = this.translate.instant('CONFIRM_MULTI_STOP_RECURRENCE')
        .replace('{count}', recurringCount.toString());
    }
    
    this.confirmationService.confirm({
      message: message,
      accept: () => {
        this.multiStopRecurrence();
      }
    });
  }

  /**
   * Delete multiple activities
   */
  multiDeleteActivities() {
    const activityIds = Array.from(this.allSelectedActivities);
    
    // Initialize progress loader configuration
    this.totalActivitiesToDelete = activityIds.length;
    this.initialEstimatedTime = this.totalActivitiesToDelete * 1.0; // 1 second per activity
    this.estimatedTimeRemaining = this.initialEstimatedTime;
    this.deletingProgress = 0;
    this.isDeletingActivities = true;

    this.progressLoaderConfig = {
      isVisible: true,
      title: this.translate.instant('DELETING_ACTIVITIES'),
      message: this.translate.instant('DONT_CLOSE_PAGE') + ' ' + this.translate.instant('DELETING_ACTIVITIES'),
      progress: 0,
      totalItems: this.totalActivitiesToDelete,
      estimatedTimeRemaining: this.estimatedTimeRemaining,
      initialEstimatedTime: this.initialEstimatedTime,
      showProgressBar: true,
      showTimeRemaining: true,
      showItemCount: true
    };

    this.activityService.multiDeleteActivities(activityIds).subscribe({
      next: (result: MultiDeleteResultDto) => {
        this.isDeletingActivities = false;
        this.deletingProgress = 100;
        // Complete the progress bar smoothly instead of just hiding
        this.completeProgressSmoothly();
        if (result.Deleted?.length !== activityIds.length ||
            result.NotFound?.length || Object.keys(result.Errors ?? {}).length) {
          this.notifications.warn('UI_NOTIFICATIONS.BULK_INCOMPLETE');
        } else {
          this.notifications.success('UI_NOTIFICATIONS.DELETED');
        }
        this.clearAllSelections();
        this.loadActivities(true);
      },
      error:error => {
        this.isDeletingActivities = false;
        this.progressLoaderConfig.isVisible = false;
        
      }
    });
  }

  /**
   * Stop recurrence for multiple activities
   */
  multiStopRecurrence() {
    const activityIds = Array.from(this.allSelectedActivities);
    
    // Initialize progress loader configuration
    this.totalActivitiesToStop = activityIds.length;
    this.stoppingInitialEstimatedTime = this.totalActivitiesToStop * 1.0; // 1 second per activity
    this.stoppingEstimatedTimeRemaining = this.stoppingInitialEstimatedTime;
    this.stoppingProgress = 0;
    this.isStoppingRecurrence = true;

    this.progressLoaderConfig = {
      isVisible: true,
      title: this.translate.instant('STOPPING_RECURRENCE'),
      message: this.translate.instant('DONT_CLOSE_PAGE') + ' ' + this.translate.instant('STOPPING_RECURRENCE'),
      progress: 0,
      totalItems: this.totalActivitiesToStop,
      estimatedTimeRemaining: this.stoppingEstimatedTimeRemaining,
      initialEstimatedTime: this.stoppingInitialEstimatedTime,
      showProgressBar: true,
      showTimeRemaining: true,
      showItemCount: true
    };

    this.activityService.multiStopRecurrence(activityIds).subscribe({
      next: (result: BulkStopRecurringActivitiesResult) => {
        this.isStoppingRecurrence = false;
        this.stoppingProgress = 100;
        // Complete the progress bar smoothly instead of just hiding
        this.completeProgressSmoothly();
        const hasFailures = result.Succeeded?.length !== activityIds.length ||
          Object.keys(result.Failed ?? {}).length > 0;
        if (hasFailures) {
          this.notifications.warn('UI_NOTIFICATIONS.BULK_INCOMPLETE');
        } else {
          this.notifications.success('UI_NOTIFICATIONS.RECURRENCE_STOPPED');
        }

        this.justStoppedRecurrence = !hasFailures;
        for (const id of result.Succeeded ?? []) {
          this.allSelectedRecurringActivities.delete(id);
        }
        
        // Keep activities selected so user can delete them afterward if needed
        this.loadActivities(true);
      },
      error:error => {
        this.isStoppingRecurrence = false;
        this.progressLoaderConfig.isVisible = false;
        
      }
    });
  }

  /**
   * Complete the progress bar smoothly to 100% and then hide
   */
  completeProgressSmoothly(): void {
    if (this.progressLoader && this.progressLoader.completeProgress) {
      this.progressLoader.completeProgress();
    } else {
      // Fallback: just hide immediately if component reference is not available
      this.progressLoaderConfig.isVisible = false;
    }
  }

  //#endregion

}
